export const bonus_round_dialogue = (t) => ({
	BONUS_ROUND_DIALOGUE_HEADER: {
		value: 'CONGRATULATIONS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 70,
			letterSpacing: 5,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_ROUND_FINISHED_HEADER: {
		value: 'CONGRATULATIONS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 70,
			letterSpacing: 5,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_ROUND_FINISHED_TEXT: {
		value: t('bonus.you_have_won'),
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	BONUS_ROUND_FINISHED_WINAMOUNT: {
		value: '$0.00',
		config: {
			fill: ['#EF9904', '#dd741d'],
			lineHeight: 1,
			fontFamily: 'Japanese',
			fontSize: 100
		}
	},
	BONUS_ROUND_FINISHED_TOTAL: {
		value: 'TOTAL',
		config: {
			fontFamily: 'Japanese',
			fontSize: 70,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_ROUND_FINISHED_NOTE: {
		value: t('bonus.press_to_continue'),
		config: {
			fill: '#F09833',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	BONUS_ROUND_DIALOGUE_TEXT_1: {
		value: t('bonus.you_have_got'),
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	BONUS_ROUND_DIALOGUE_TEXT_2: {
		value: '13 BONUS SPINS',
		config: {
			fontFamily: 'Japanese',
			fill: ['#EF9904', '#dd741d'],
			fontSize: 105
		}
	},
	BONUS_ROUND_DIALOGUE_TEXT_3: {
		value: t('bonus.press_to_start'),
		config: {
			fill: '#F09833',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	BONUS_ROUND_DIALOGUE_TEXT_4: {
		value: t('bonus.catch_special_crystal'),
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20,
			align: 'center'
		}
	}
});
